/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Close = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="close" />;

export { Close, Close as default };
